/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "446")


  
    
export interface API48245Item {
  
  /**  */
  code?: number;
  
  /**  */
  desc?: string;
  
};
    
  



  export type API48245Req = {};



export interface API48245Res {
  /** T  */
  list?: API48245Item[];
  
};


// 48245 任务创建类型枚举列表

export interface IUseGetAPI48245Return {
  /** 任务创建类型枚举列表: 接口请求状态 */
  isAPI48245Loading: boolean;
  /** 任务创建类型枚举列表: 接口请求返回数据 */
  dataAPI48245: API48245Res;
  /**  任务创建类型枚举列表: 接口数据请求方法 */
  fetchAPI48245Data:  ( config?: YWRequestConfig) => Promise<API48245Res>;
  /** 任务创建类型枚举列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48245 = ():IUseGetAPI48245Return => {
  let isMount = true;
  const [isAPI48245Loading, setIsAPI48245Loading] = useState(false);
  const [dataAPI48245, setDataAPI48245] = useState<API48245Res>({} as API48245Res);
  const requestUrl = `${basePath}/team-work/workTask/listTaskCreateTypeEnum`;

  const fetchAPI48245Data = async ( config?: YWRequestConfig): Promise<API48245Res> => {
  
    if ( isMount ) {
      setIsAPI48245Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48245Res>(`${basePath}/team-work/workTask/listTaskCreateTypeEnum`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48245(res || {} as API48245Res);
        setIsAPI48245Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48245Loading(false);
      }
      return false as unknown as API48245Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48245Loading,
    dataAPI48245,
    fetchAPI48245Data,
    requestUrl,
  }
}

